import axios from './axios'

//左侧菜单
export function getSuccessMenu (options) {
  return axios.get('/api/v1/web/cases/disease_list', options);
}

//成功案例列表
export function getSuccessCaseList (options) {
  return axios.get('/api/v1/web/cases/cases_list?id=' + options.id + '&disease_id=' + options.disease_id + '&type_id=' + options.type_id + '&page=' + options.page);
}

//成功案例详情
export function getCaseDetail (options) {
  return axios.get('/api/v1/web/cases/cases_info?id=' + options.id);
}

